module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1509-2e9c710d51291e5018f338166d686aaa.png";